import { useEffect, useState } from 'react'
import AnimationLayout from './components/AnimationLayout'

interface Badge {
  name: string
  emoji: string
  description: string
  points_awarded: number
}

interface Props {
  animation: { id: number; name: string; description: string }
  badge: Badge
  all_animations: { id: number; name: string }[]
}

interface Sparkle {
  id: number
  x: number
  y: number
  size: number
  delay: number
}

export default function Animation12({ animation, badge, all_animations }: Props) {
  const [showBadge, setShowBadge] = useState(false)
  const [sparkles, setSparkles] = useState<Sparkle[]>([])

  useEffect(() => {
    setTimeout(() => setShowBadge(true), 200)

    const newSparkles: Sparkle[] = []
    for (let i = 0; i < 30; i++) {
      newSparkles.push({
        id: i,
        x: Math.random() * 100,
        y: Math.random() * 100,
        size: Math.random() * 10 + 5,
        delay: Math.random() * 2
      })
    }
    setSparkles(newSparkles)
  }, [])

  return (
    <AnimationLayout animation={animation} allAnimations={all_animations}>
      <style>{`
        @keyframes sparkle {
          0%, 100% {
            opacity: 0;
            transform: scale(0) rotate(0deg);
          }
          50% {
            opacity: 1;
            transform: scale(1) rotate(180deg);
          }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-20px); }
        }
        .sparkle {
          animation: sparkle 2s ease-in-out infinite;
        }
        .float {
          animation: float 3s ease-in-out infinite;
        }
      `}</style>

      <div className="flex flex-col items-center justify-center min-h-[50vh] sm:min-h-[60vh] relative">
        {/* Particules dorées */}
        <div className="absolute inset-0 pointer-events-none overflow-hidden">
          {sparkles.map((sparkle) => (
            <div
              key={sparkle.id}
              className="sparkle absolute text-tessan-yellow"
              style={{
                left: `${sparkle.x}%`,
                top: `${sparkle.y}%`,
                fontSize: `${sparkle.size}px`,
                animationDelay: `${sparkle.delay}s`
              }}
            >
              ✦
            </div>
          ))}
        </div>

        {/* Badge doré */}
        <div className={`relative z-10 float transition-all duration-700 ${showBadge ? 'scale-100 opacity-100' : 'scale-0 opacity-0'}`}>
          <div className="relative">
            {/* Halo doré */}
            <div className="absolute inset-0 blur-2xl bg-tessan-yellow opacity-30 scale-125 rounded-2xl" />

            {/* Badge */}
            <div className="relative w-32 h-32 sm:w-44 sm:h-44 bg-tessan-cream rounded-2xl flex items-center justify-center shadow-2xl shadow-tessan-yellow/50 border-4 border-tessan-yellow/50">
              <span className="text-6xl sm:text-8xl">{badge.emoji}</span>
            </div>
          </div>
        </div>

        <div className={`mt-8 text-center transition-all duration-500 delay-500 ${showBadge ? 'opacity-100' : 'opacity-0'}`}>
          <div className="text-2xl sm:text-4xl font-black text-tessan-yellow">{badge.name}</div>
          <div className="text-lg sm:text-xl text-tessan-cream mt-2">+{badge.points_awarded} points</div>
          <div className="text-tessan-cream/70 mt-4 max-w-[280px] sm:max-w-xs">{badge.description}</div>
        </div>
      </div>
    </AnimationLayout>
  )
}
